import { render, staticRenderFns } from "./PatientViewModal.vue?vue&type=template&id=5bce2f51&"
import script from "./PatientViewModal.vue?vue&type=script&lang=js&"
export * from "./PatientViewModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientViewModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports